import store from '@/store'

import TextInfo from '@/components/datainfo/TextInfo'
import TypeItem from '@/components/datainfo/TypeItem'
import FileInfo from '@/components/datainfo/FileInfo'

import fileConf from '@/syslib/file_conf'

import {
  sysVersionList
} from './sys_version'

import {
  sysInstanceList
} from './sys_instance'

import {
  sysRequest
} from '@/api'

let formParms = [{
  type: 'input',
  label: '名称',
  key: 'name',
  check: {
    required: true
  }
},
{
  type: 'textarea',
  label: '说明',
  key: 'description'
}]

export const sysList = function (parm = {}) {
  let config = {
    key: parm.key || 'sys',
    titleConfig: {
      title: parm && parm.title ? parm.title : '系统',
      titleMenus: parm && parm.titleMenus ? parm.titleMenus : [{
        key: 'add',
        label: '新增'
      }]
    },
    listConfig: {
      filterFun (data, parm) {
        return data.filter((v) => {
          let need = parm ? v.name.includes(parm) : true
          return need
        })
      },
      listMenus: parm && parm.listMenus ? parm.listMenus : [
        {
          key: 'task',
          label: '相关任务',
          dealFun (data, vm) {
            vm.$router.push({
              name: 'task', query: {
                type: 'sys',
                id: data.id
              }
            })
          }
        },
        {
          key: 'edit',
          label: '修改'
        },
        {
          key: 'del',
          label: '删除'
        }
      ],
      config: sys(),
      getTitle: (data) => {
        return data.name + ' ' + (data.description || '')
      }
    },
    async getData (dataParm) {
      let data = await sysRequest.get({id: dataParm && dataParm.id ? dataParm.id : null})
      if (!dataParm) {
        store.dispatch('setSysList', data)
      } else {
        store.dispatch('loadSysList', true)
      }
      return data
    },
    updateConfig: {
      title: '系统',
      request: sysRequest,
      getFormParms () {
        return formParms
      }
    }
  }
  if (parm.openConf) {
    config.openConf = parm.openConf
  }
  return config
}

export const sys = function ({defaultOpen} = {}) {
  let config = {
    defaultOpen: defaultOpen || false,
    getTitle: (data) => {
      return data ? data.name + ' ' + (data.description || '') : ''
    },
    async getData (dataParm) {
      let data = await sysRequest.get({id: dataParm && dataParm.id ? dataParm.id : null})
      return data && data.length === 1 ? data[0] : null
    },
    getInfoParm: (data) => {
      return data ? [{
        comp: TextInfo,
        config: {
          infoParm: formParms.filter(v => v.key !== 'name').map((v) => {
            return {
              label: v.label,
              field: v.key
            }
          })
        }
      },
      {
        comp: TypeItem,
        dataParm: {
          sysId: data.id
        },
        config: sysInstanceList()
      },
      {
        comp: TypeItem,
        dataParm: {
          sysId: data.id
        },
        config: sysVersionList()
      },
      {
        comp: FileInfo,
        config: {
          filePath: fileConf.sys ? fileConf.sys.getPath(data) : null
        }
      }] : []
    }
  }
  return config
}
